import React from 'react';
import { LayoutTree } from '../../../../DynamicLayout';
import { useTranslations } from '../../../../../../hooks/useTranslations';
import {
  useAnalyticsPost,
  NarvarEventTypes,
  NarvarEventComponents,
  NarvarClickTypes,
  NarvarClickSubTypes,
  flushAnalyticsQueueSync,
} from '../../../../../../hooks/Analytics';
import styles from './LineLogin.module.css';

const { FeatureLayout } = LayoutTree;

export interface LineLoginProps {
  url: string;
  featureName?: string;
  layout?: LayoutTree.FeatureLayout;
}

const LineLogin = ({ url, featureName, layout }: LineLoginProps) => {
  const logEvent = useAnalyticsPost();
  const { notificationCenterLineLoginButtonText } = useTranslations();

  const handleLogin: React.MouseEventHandler<HTMLAnchorElement> = (e): void => {
    e.preventDefault();
    logEvent({
      clickCategory: NarvarClickSubTypes.LINE_SIGNUP,
      clickNotificationIsOptIn: true,
      clickSubType: NarvarClickSubTypes.LINE_SIGNUP,
      clickType: NarvarClickTypes.INTERACTION,
      eventComponent: NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
      eventFeature: NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
      eventType: NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
    });

    // Make sure the event logged above fires off before executing the redirect
    flushAnalyticsQueueSync();

    window.location.href = url;
  };

  const isLandscape = layout === FeatureLayout.LANDSCAPE;

  return (
    <div className={isLandscape ? styles.containerLandscape : styles.container}>
      <a className={styles.button} href={url} onClick={handleLogin}>
        <img
          className={styles.icon}
          src="https://assets.narvar.com/assets/line_login_icon.svg"
          alt=""
        />
        <div className={styles.divider} />
        <div className={styles.text}>
          {notificationCenterLineLoginButtonText}
        </div>
      </a>
    </div>
  );
};

export default LineLogin;
